import React from 'react';
import HomeApp from './HomeApp';

export default function MainPage(props) {
    return <HomeApp {...props} />;
}
